import Link from 'next/link'
import { Button } from '@/components/ui/button'
import { ArrowRight } from 'lucide-react'

type InternalLinkDoc = {
  slug?: string | null
  relationTo?: 'pages' | 'courses' | 'blogs'
  value?: { slug?: string | null } | string | number
}

type CallToActionBlockProps = {
  blockType: 'pageCallToAction'
  id?: string | null
  heading?: string | null
  description?: string | null
  buttonText?: string | null
  buttonLink?: string | null // legacy field
  linkType?: 'internal' | 'external' | null
  internalLink?: InternalLinkDoc | null
  externalUrl?: string | null
  newTab?: boolean | null
}

function getInternalUrl(link: InternalLinkDoc | null | undefined): string | null {
  if (!link) return null

  const doc = typeof link.value === 'object' ? link.value : null
  const slug = doc?.slug

  if (!slug) return null

  switch (link.relationTo) {
    case 'pages':
      return `/${slug}`
    case 'courses':
      return `/cursussen/${slug}`
    case 'blogs':
      return `/blog/${slug}`
    default:
      return `/${slug}`
  }
}

export const CallToActionBlockComponent: React.FC<CallToActionBlockProps> = ({
  heading,
  description,
  buttonText,
  buttonLink,
  linkType,
  internalLink,
  externalUrl,
  newTab,
}) => {
  // Determine the href - support both new link fields and legacy buttonLink
  let href: string | null = null
  if (linkType === 'internal') {
    href = getInternalUrl(internalLink)
  } else if (linkType === 'external') {
    href = externalUrl || null
  } else if (buttonLink) {
    // Legacy fallback
    href = buttonLink
  }

  const linkProps = newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {}

  return (
    <div className="mt-10 rounded-2xl bg-muted/50 p-6 sm:p-8">
      {heading && (
        <h3 className="text-lg font-semibold text-foreground sm:text-xl">
          {heading}
        </h3>
      )}
      {description && (
        <p className="mt-2 text-muted-foreground">{description}</p>
      )}
      {buttonText && href && (
        <div className="mt-4">
          <Button asChild className="rounded-full">
            <Link href={href} className="inline-flex items-center gap-2" {...linkProps}>
              {buttonText}
              <ArrowRight className="h-4 w-4" />
            </Link>
          </Button>
        </div>
      )}
    </div>
  )
}
